import { Icon } from '@iconify/react'
import homeFill from '@iconify/icons-eva/home-fill'
import fileFill from '@iconify/icons-eva/file-fill'
import roundGrain from '@iconify/icons-ic/round-grain'
import homeFill2 from '@iconify/icons-eva/home-fill'
import peopleFill from '@iconify/icons-eva/people-fill'
import imageFill from '@iconify/icons-eva/image-fill'
import phoneCallFill from '@iconify/icons-eva/phone-call-fill'
import settings2Fill from '@iconify/icons-eva/settings-2-fill'
import briefcaseFill from '@iconify/icons-eva/person-outline'
// import briefcaseFill from '@iconify/mingcute/group-3-fill'

// routes
import {
  PATH_AUTH,
  PATH_DOCS,
  PATH_PAGE,
  PATH_DASHBOARD,
} from '../../routes/paths'
import { Stack } from '@material-ui/core'

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 20,
  height: 20,
}

const menuConfig = [
  {
    title: 'Home',
    icon: <Icon icon={homeFill} {...ICON_SIZE} />,
    path: '/',
  },
  {
    title: 'About Us',
    icon: <Stack className='mingcute--group-3-fill' {...ICON_SIZE} />,
    // path: PATH_PAGE.comingSoon,
    path: PATH_PAGE.aboutus,
  },
  // {
  //   title: 'Components',
  //   icon: <Icon icon={roundGrain} {...ICON_SIZE} />,
  //   path: PATH_PAGE.components,
  // },
  {
    title: 'Our Team',
    icon: <Icon icon={peopleFill} {...ICON_SIZE} />,
    path: PATH_PAGE.leadershipteam,
  },
  {
    title: 'Services',
    icon: <Icon icon={settings2Fill} {...ICON_SIZE} />,
    path: PATH_PAGE.services,
  },
  {
    title: 'Gallery',
    icon: <Icon icon={imageFill} {...ICON_SIZE} />,
    path: PATH_PAGE.gallery,
  },
  {
    title: 'Contact Us',
    icon: <Icon icon={phoneCallFill} {...ICON_SIZE} />,
    // path: PATH_PAGE.comingSoon,
    path: PATH_PAGE.contactus,
  },

  // {
  //   title: 'Pages',
  //   path: '/pages',
  //   icon: <Icon icon={fileFill} {...ICON_SIZE} />,
  //   children: [
  //     {
  //       subheader: 'Other',
  //       items: [
  //         { title: 'About us', path: PATH_PAGE.about },
  //         { title: 'Contact us', path: PATH_PAGE.contact },
  //         { title: 'FAQs', path: PATH_PAGE.faqs },
  //         { title: 'Pricing', path: PATH_PAGE.pricing },
  //         { title: 'Payment', path: PATH_PAGE.payment },
  //         { title: 'Maintenance', path: PATH_PAGE.maintenance },
  //         { title: 'Coming Soon', path: PATH_PAGE.comingSoon },
  //       ],
  //     },
  //     {
  //       subheader: 'Authentication',
  //       items: [
  //         { title: 'Login', path: PATH_AUTH.loginUnprotected },
  //         { title: 'Register', path: PATH_AUTH.registerUnprotected },
  //         { title: 'Reset password', path: PATH_AUTH.resetPassword },
  //         { title: 'Verify code', path: PATH_AUTH.verify },
  //       ],
  //     },
  //     {
  //       subheader: 'Error',
  //       items: [
  //         { title: 'Page 404', path: PATH_PAGE.page404 },
  //         { title: 'Page 500', path: PATH_PAGE.page500 },
  //       ],
  //     },
  //     {
  //       subheader: 'Dashboard',
  //       items: [{ title: 'Dashboard', path: PATH_DASHBOARD.root }],
  //     },
  //   ],
  // },
  // {
  //   title: 'Documentation',
  //   icon: <Icon icon={bookOpenFill} {...ICON_SIZE} />,
  //   path: PATH_DOCS.root,
  // },
]

export default menuConfig
